import React from 'react';
import { Link } from "react-router-dom";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

const Disclaimer = () => {
	return (
		<div style={{ 
			minHeight: '100vh', 
			background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #60a5fa 100%)',
			paddingTop: '70px',
			paddingBottom: '70px'
		}}>
			{/* Top Navbar */}
			<Navbar expand="sm" fixed="top" style={{ 
				background: 'rgba(255, 255, 255, 0.95)',
				backdropFilter: 'blur(10px)',
				boxShadow: '0 2px 20px rgba(0,0,0,0.1)'
			}}>
				<Link to="/" style={{ marginLeft: '1rem' }}>
					<img src="/images/p10.jpg" alt="Logo" style={{ height: '40px', borderRadius: '8px' }} />
				</Link>
				<Nav className="ml-auto" style={{ marginRight: '1rem' }}>
					<Link to="/about" style={{ 
						color: '#1e3a8a', 
						textDecoration: 'none',
						fontWeight: '600',
						marginLeft: '1.5rem'
					}}>
						About
					</Link>
				</Nav>
			</Navbar>

			{/* Main Content */}
			<div style={{ 
				display: 'flex', 
				justifyContent: 'center', 
				alignItems: 'center',
				minHeight: 'calc(100vh - 140px)',
				padding: '40px 20px'
			}}>
				<div style={{ 
					maxWidth: '900px',
					width: '100%',
					background: 'white',
					borderRadius: '20px',
					padding: '3rem',
					boxShadow: '0 15px 50px rgba(0,0,0,0.25)'
				}}>
					<h1 style={{ 
						fontSize: '2.5rem',
						fontWeight: '700',
						marginBottom: '0.5rem',
						color: '#1e3a8a',
						textAlign: 'center'
					}}>
						Disclaimer
					</h1>
					<p style={{ 
						textAlign: 'center', 
						color: '#718096',
						marginBottom: '2rem',
						fontSize: '1.1rem'
					}}>
						Last updated: January 21, 2025
					</p>
					
					<div style={{ 
						color: '#4a5568',
						lineHeight: '1.8',
						fontSize: '1rem'
					}}>
						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Interpretation and Definitions
						</h2>

						<h3 style={{ 
							fontSize: '1.4rem',
							fontWeight: '600',
							marginTop: '1.5rem',
							marginBottom: '0.75rem',
							color: '#2563eb'
						}}>
							Interpretation
						</h3>
						<p style={{ marginBottom: '1.5rem' }}>
							The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
						</p>

						<h3 style={{ 
							fontSize: '1.4rem',
							fontWeight: '600',
							marginTop: '1.5rem',
							marginBottom: '0.75rem',
							color: '#2563eb'
						}}>
							Definitions
						</h3>
						<p style={{ marginBottom: '1rem' }}>For the purposes of this Disclaimer:</p>
						<ul style={{ 
							marginBottom: '1.5rem',
							paddingLeft: '1.5rem',
							lineHeight: '2'
						}}>
							<li><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Disclaimer) refers to p10 rating.</li>
							<li><strong>Service</strong> refers to the Website.</li>
							<li><strong>You</strong> means the individual accessing the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
							<li><strong>Website</strong> refers to p10 rating, accessible from <a href="https://www.p10rating.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#3b82f6' }}>https://www.p10rating.com/</a></li>
						</ul>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Disclaimer
						</h2>
						<p style={{ marginBottom: '1rem' }}>
							The information contained on the Service is for general information purposes only.
						</p>
						<p style={{ marginBottom: '1rem' }}>
							The Company assumes no responsibility for errors or omissions in the contents of the Service.
						</p>
						<p style={{ marginBottom: '1.5rem' }}>
							In no event shall the Company be liable for any special, direct, indirect, consequential, or incidental damages or any damages whatsoever, whether in an action of contract, negligence or other tort, arising out of or in connection with the use of the Service or the contents of the Service. The Company reserves the right to make additions, deletions, or modifications to the contents on the Service at any time without prior notice.
						</p>
						<p style={{ marginBottom: '1.5rem' }}>
							The Company does not warrant that the Service is free of viruses or other harmful components.
						</p>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							External Links Disclaimer
						</h2>
						<p style={{ marginBottom: '1rem' }}>
							The Service may contain links to external websites that are not provided or maintained by or in any way affiliated with the Company.
						</p>
						<p style={{ marginBottom: '1.5rem' }}>
							Please note that the Company does not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.
						</p>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Errors and Omissions Disclaimer
						</h2>
						<p style={{ marginBottom: '1rem' }}>
							The information given by the Service is for general guidance on matters of interest only. Even if the Company takes every precaution to insure that the content of the Service is both current and accurate, errors can occur. Plus, given the changing nature of laws, rules and regulations, there may be delays, omissions or inaccuracies in the information contained on the Service.
						</p>
						<p style={{ marginBottom: '1.5rem' }}>
							The Company is not responsible for any errors or omissions, or for the results obtained from the use of this information.
						</p>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Fair Use Disclaimer
						</h2>
						<p style={{ marginBottom: '1rem' }}>
							The Company may use copyrighted material which has not always been specifically authorized by the copyright owner. The Company is making such material available for criticism, comment, news reporting, teaching, scholarship, or research.
						</p>
						<p style={{ marginBottom: '1rem' }}>
							The Company believes this constitutes a "fair use" of any such copyrighted material as provided for in section 107 of the United States Copyright law.
						</p>
						<p style={{ marginBottom: '1.5rem' }}>
							If You wish to use copyrighted material from the Service for your own purposes that go beyond fair use, You must obtain permission from the copyright owner.
						</p>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Views Expressed Disclaimer
						</h2>
						<p style={{ marginBottom: '1rem' }}>
							The Service may contain views and opinions which are those of the authors and do not necessarily reflect the official policy or position of any other author, agency, organization, employer or company, including the Company.
						</p>
						<p style={{ marginBottom: '1.5rem' }}>
							Comments published by users are their sole responsibility and the users will take full responsibility, liability and blame for any libel or litigation that results from something written in or as a direct result of something written in a comment. The Company is not liable for any comment published by users and reserve the right to delete any comment for any reason whatsoever.
						</p>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							No Responsibility Disclaimer
						</h2>
						<p style={{ marginBottom: '1rem' }}>
							The information on the Service is provided with the understanding that the Company is not herein engaged in rendering legal, accounting, tax, or other professional advice and services. As such, it should not be used as a substitute for consultation with professional accounting, tax, legal or other competent advisers.
						</p>
						<p style={{ marginBottom: '1.5rem' }}>
							In no event shall the Company or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever arising out of or in connection with your access or use or inability to access or use the Service.
						</p>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							"Use at Your Own Risk" Disclaimer
						</h2>
						<p style={{ marginBottom: '1rem' }}>
							All information in the Service is provided "as is", with no guarantee of completeness, accuracy, timeliness or of the results obtained from the use of this information, and without warranty of any kind, express or implied, including, but not limited to warranties of performance, merchantability and fitness for a particular purpose.
						</p>
						<p style={{ marginBottom: '1.5rem' }}>
							The Company will not be liable to You or anyone else for any decision made or action taken in reliance on the information given by the Service or for any consequential, special or similar damages, even if advised of the possibility of such damages.
						</p>

						<h2 style={{ 
							fontSize: '1.8rem',
							fontWeight: '600',
							marginTop: '2rem',
							marginBottom: '1rem',
							color: '#1e3a8a'
						}}>
							Contact Us
						</h2>
						<p style={{ marginBottom: '0' }}>
							If you have any questions about this Disclaimer, You can contact Us:
						</p>
						<ul style={{ 
							paddingLeft: '1.5rem',
							lineHeight: '2'
						}}>
							<li>By email: <a href="mailto:p10rating@gmail.com" style={{ color: '#3b82f6' }}>info@p10rating.com</a></li>
						</ul>
					</div>
				</div>
			</div>

			{/* Bottom Navbar */}
			<Navbar fixed="bottom" style={{ 
				background: 'rgba(255, 255, 255, 0.95)',
				backdropFilter: 'blur(10px)',
				boxShadow: '0 -2px 20px rgba(0,0,0,0.1)',
				padding: '1rem'
			}}>
				<Nav style={{ 
					width: '100%', 
					display: 'flex', 
					justifyContent: 'center',
					flexWrap: 'wrap',
					gap: '0.5rem'
				}}>
					<span style={{ margin: '0 0.5rem', color: '#4a5568', fontWeight: '500' }}>
						p10rating © 2026
					</span>
					<Link to='/privacypolicy' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
						Privacy
					</Link>
					<Link to='/terms' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
						Terms
					</Link>
					<Link to='/about' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
						About
					</Link>
					<Link to='/' style={{ margin: '0 0.5rem', color: '#3b82f6', textDecoration: 'none', fontWeight: '500' }}>
						Sign In
					</Link>
				</Nav>
			</Navbar>
		</div>
	);
}

export default Disclaimer;